import { render, staticRenderFns } from "./ExchangeStats.vue?vue&type=template&id=0e855d3b&scoped=true&lang=pug"
import script from "./ExchangeStats.vue?vue&type=script&lang=js"
export * from "./ExchangeStats.vue?vue&type=script&lang=js"
import style0 from "./ExchangeStats.vue?vue&type=style&index=0&id=0e855d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e855d3b",
  null
  
)

export default component.exports